<template>
  <div class="page">
    <!-- header -->
    <xh-header />

    <!-- banner -->
    <ny-banner v-if="banner.length" :banner="banner[0]" />

    <!-- 面包屑 -->
    <div class="crumbs">
      <div>{{ wenzhang[1].name }} {{ filterSubtype }}</div>
    </div>

    <div class="ny-tabs">
      <ul>
        <li
          v-for="item in wenzhang[1].children"
          :key="item.name"
          :class="{'action': item.id === parseInt(subType)}"
          @click="$router.push(item.path)"
        >{{ item.name }}</li>
      </ul>
    </div>

    <div class="container-width" v-if="taskDetail">
      <div class="detail">
        <h3 class="title">{{taskDetail.title}}</h3>
        <p class="date">
          <img src="../../../../assets/images/date.png" />
          {{ taskDetail.publishTime ? formatDate(Date.parse(taskDetail.publishTime)) : '' }}

        </p>
        <div class="content" style="padding-bottom: 0; padding-top: 0" v-if="taskDetail.taskInfoDto && taskDetail.taskInfoDto.content">
          <iframe class="iframe-container"
            id="myIframe"
            sandbox="allow-same-origin"
            :src="taskDetail.taskInfoDto.content"
            :style="{height: taskDetail.taskInfoDto.height ? (parseFloat(taskDetail.taskInfoDto.height) - 85) + 'px' : 'auto'}"
            frameborder="0"
          ></iframe>
        </div>
        <div class="view">
          <img src="../../../../assets/images/view.png" />
          阅读人数：{{ taskDetail.readNum || 0 }}人
        </div>
      </div>
    </div>
    <div class="container-width" v-else>
      <div class="detail">
        <h3 class="title">{{detail.title}}</h3>
        <p class="date">
          <img src="../../../../assets/images/date.png" />
          {{ detail.createTime ? formatDate(Date.parse(detail.createTime)) : '' }}

        </p>
        <!-- <div class="content" v-html="detail.content"></div> -->
        <iframe class="iframe-container"
          id="myIframe"
          sandbox="allow-same-origin"
          src="http://admin.shanghaivolleyball.com/saved_page/b4bada0de6434b49b935bb6cb91d548d/page.html"
          frameborder="0"
        ></iframe>
        <!-- <div class="pa">
          <div class="fl">上一条：五星体育星辰大海杯排球比赛</div>
          <div class="fr">下一条：五星体育星辰大海杯排球比赛</div>
        </div> -->
        <div class="view">
          <img src="../../../../assets/images/view.png" />
          阅读人数：{{ detail.readNum || 0 }}人
        </div>
      </div>
    </div>

    <!-- footer -->
    <xh-footer />
  </div>
</template>
<script>
import XhHeader from '../../reveals/xh-header.vue'
import XhFooter from '../../reveals/xh-footer.vue'
import NyBanner from '../../sections/ny-banner.vue'
import { getBanner } from '@/service/apis/common'
import { wenzhang } from '@/page/constants'
import { getNewsDetail } from '@/service/apis/news'


export default {
  components: {
    XhHeader,
    XhFooter,
    NyBanner
  },
  name: 'NoticeDetail',
  data () {
    return {
      wenzhang,
      type: '',
      subType: '',
      id: '',
      banner: [],
      taskDetail: null, // 站外内容详情
      detail: {
        title: '',
        author: '',
        createTime: '',
        readNum: '',
        content: ''
      }
    }
  },

  computed: {
    filterSubtype () {
      let list = wenzhang[1].children
      let filter = list.filter(item => item.id === parseInt(this.subType))
      return filter.length ? `> ${filter[0].name}` : ''
    }
  },
  created() {
    getBanner(this).then(data => {
      // 新闻资讯 banner 8
      if (data[8]) {
        this.banner = [...data[8]]
      }
    })
    let ids = this.$route.query.id
    if (!ids) {
      this.$router.back()
    } else {
      let arr = ids.split('-')
      this.type = arr[0]
      this.subType = arr[1]

      if (arr[2]) {
        this.id = arr[2]
        this.getDetail(arr[2])
      } else {
        this.$router.back()
      }
    }
  },
  methods: {
    getDetail (id) {
      getNewsDetail.call(this, { id }).then(res => {
        if (res.errCode === 0) {
          const data = res.data
           // 站外内容
          if (data && data.sourceType == 2) {
            this.taskDetail = data
            // 如果是iframe
            this.initIframe()
          } else {
            if (data.newsDetailDto) {
              this.detail.title = data.title
              this.detail.author = data.author
              this.detail.createTime = data.createTime
              this.detail.readNum = data.readNum
              this.detail.content = data.newsDetailDto.content || ''
            }
          }
        }
      })
    },
    initIframe () {
      console.log('init Iframe')
      this.$nextTick(() => {
        setTimeout(() => {
          let iframe = document.getElementById('myIframe')
          var iwindow = iframe.contentWindow;
          var idoc = iwindow.document;
          iframe.height = idoc.body.offsetHeight;
          // iframe.width = idoc.body.offsetWidth;
          // 设置iframe的高度和宽度
          iframe.style.height = idoc.body.offsetHeight + 'px';
          // iframe.style.width = idoc.body.offsetWidth + 'px';
          console.log(idoc.body.offsetHeight, 'xxooo')
        }, 50)
      })
    }
  },
}
</script>
<style scoped>
.detail {
  padding-top: 30px;
  height: auto;
  overflow: hidden;
}
.detail h3.title {
  font-size: 36px;
  line-height: 44px;
  text-align: center;
}
.detail .date {
  margin: 12px 0;
  line-height: 18px;
  text-align: center;
}
.detail .date img {
  vertical-align: middle;
}
.detail .content {
  padding: 12px 0;
  padding-bottom: 48px;
  color: #666;
  min-height: 250px;
  line-height: 28px;
}
.detail .content img {
  max-width: 100%;
}
.pa {
  padding: 0 24px;
  height: 56px;
  line-height: 56px;
  background-color: #f9faff;
}
.view {
  color: #999;
  margin: 32px 0;
  line-height: 16px;
  text-align: right;
}

.iframe-container {
  width: 100%;
  height: auto;
  min-height: 100vh;
  overflow: hidden;
}

@media screen and (max-width: 736px) {
  .detail h3.title {
    font-size: 22px;
    line-height: 28px;
  }
  .pa {
    height: auto;
    overflow: hidden;
    line-height: 24px;
  }
  .pa div {
    margin: 6px 0;
    width: 100%;
  }
  }
</style>
